import React from "react";
import { Col, Card, Spinner } from "react-bootstrap";
import ImageLoader from "react-imageloader";
import { useNavigate } from "react-router-dom";
import { PROJECT_PATH } from "../../configs/constants/paths";
import { areEqual } from "../../editor/utils/comparison";
import InlineEditableTitle from "../../core/InlineEditableTitle";
import { editScreen } from "../../context/fetch/fetchProjects";

const AllScreens = ({ screens, handleOnRemoveClick, id, dispatch, updateScreenInList }) => {
  const navigate = useNavigate();

  const handleTitleSave = async (screenId, newTitle) => {
    const sendingData = {
      data: { name: newTitle },
      id: screenId,
    };

    await editScreen(dispatch, sendingData);
    if (updateScreenInList) {
      updateScreenInList(screenId, newTitle);
    }
  };

  const handleCardClick = (screenId) => {
    navigate(`${PROJECT_PATH}/view-list/${id}#${screenId}`);
  };

  const handleDeleteClick = (e, screenId) => {
    e.preventDefault();
    e.stopPropagation();
    handleOnRemoveClick(screenId);
  };

  return screens.map((screen, i) => (
    <Col lg={4} sm={6} className={" mb-3"} key={i}>
      <Card className={"cursor-pointer"} onClick={() => handleCardClick(screen.id)}>
        <Card.Body className={"p-2"}>
          <InlineEditableTitle
            title={screen.name}
            onSave={(newTitle) => handleTitleSave(screen.id, newTitle)}
            placeholder="Screen name"
            className="mb-0"
          />
          <div>
            <Card.Text>
              RATING: {screen.tracking_rating ? `5/${screen.tracking_rating}` : "Not available"}
            </Card.Text>
            <Card.Text
              style={{
                color:
                  screen.status === "Active"
                    ? "#4CAF50"
                    : screen.status === "Processing" || screen.status === "Inactive"
                      ? "#ff9800"
                      : "#f44336",
              }}
            >
              STATUS: {screen.status ? screen.status : "Not available"}
            </Card.Text>
          </div>
        </Card.Body>
        <Card.Body className={"p-0"}>
          <div className={"project-img-box"}>
            <ImageLoader
              src={screen.imgUrl}
              wrapper={React.createFactory("div")}
              preloader={() => <Spinner animation="grow" variant="primary" />}
            >
              Image load failed!
            </ImageLoader>
          </div>
        </Card.Body>
        <Card.Body className={"p-2 card-footer"}>
          <Card.Link onClick={(e) => handleDeleteClick(e, screen.id)}>Delete</Card.Link>
        </Card.Body>
      </Card>
    </Col>
  ));
};

export default React.memo(AllScreens, areEqual);
